<template>
  <div>
    <div class="edit__form">
      <label class="edit__form-label">点数</label>
      <div class="edit__form-input">
        <div style="display:flex;gap:5px;align-items: center;">
          <div>
            <input type="number" name="set_product[item_count]" v-model="itemCount" id="SetProductItemCount" data-validation="set_product.item_count">
          </div>
          <button class="edit__button" type="button" @click="applyItem">適用</button>
        </div>
      </div>
    </div>

    <div class="set-product-detail__title-wrapper">
      <h3>セット内容</h3>
    </div>
    <draggable v-model="items" item-key="id" handle=".set-product-detail__handle" animation="200">
      <template #item="{ element }">
        <div class="set-product-detail__item">
          <span v-if="sortDiv == 1"></span>
          <span class="set-product-detail__handle" v-if="sortDiv == 2">☰</span>
          <select :ref="el => el && (selectRefs[element.index] = el)" name="set_product[child_product_id][]"></select>
        </div>
      </template>
    </draggable>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, nextTick, watchEffect } from "vue";
import draggable from "vuedraggable";
import TomSelect from "tom-select";

const sortDiv = productSortDiv;
const items = ref([]);
const selectRefs = reactive({});
const itemCount = ref([]);
let nextId = jsonData.length + 1;

function initSelects() {
  nextTick(() => {
    items.value.forEach((item) => {
      const el = selectRefs[item.index];
      if (!el) return;

      if (el.tomselect) el.tomselect.destroy();

      const ts = new TomSelect(el, {
        valueField: "id",
        labelField: "name",
        searchField: "name",
        preload: true,
        allowEmptyOption: true,
        load: function (query, callback) {
          fetch(
            `/search_api/single_products/code/name?q=${encodeURIComponent(
              query
            )}`
          )
            .then((res) => res.json())
            .then(callback)
            .catch(() => callback([]));
        },
        onDropdownClose() {
          const value = ts.items[0] || "";
          const matchedOption = ts.options[value];

          if (matchedOption) {
            item.id = matchedOption.id;
            item.name = matchedOption.name;
          } else {
            item.id = "";
            item.name = "";
          }
          nextTick(() => initSelects());
        },
      });

      // 初期 option を追加・選択
      if (item.id && item.name) {
        ts.addOption({ id: item.id, name: item.name });
        ts.setValue(item.id);
      }
    });
  });
}

// 初期化
onMounted(() => {
  if (jsonData.length > 0) {
    items.value = jsonData.map((item) => ({ ...item }));
  }
  itemCount.value = productItemCount;
  initSelects();
  applyItem();
});

// 自動再初期化（並び替え・追加・削除）
watchEffect(() => {
  initSelects();
});

// 追加
function applyItem() {
  const currentCount = items.value.length;
  if (currentCount < itemCount.value) {
    for (let index = 0; index < itemCount.value - currentCount; index++) {
      items.value.push({ index: index, id: nextId++, name: "" });
    }
  } else {
    let tmpItems = [];
    for (let index = 0; index < itemCount.value; index++) {
      const keys = Object.keys(items.value);
      const key = keys[index];
      tmpItems.push(items.value[key]);
    }
    items.value = tmpItems;
  }
  nextTick();
  initSelects();
}
</script>